<template>
  <VContent>
    <template slot="right">
      <h6>{{ title }}</h6>
    </template>
    <template slot="left">
      <b-button
        size="sm"
        variant="success"
        class="ml-3"
        @click="updateServices('someType')"
        >تحديث</b-button
      >
    </template>
    <template slot="content">
      <template>
        <div
          class="p-2 mb-2 rounded-pill status-indicator"
          :class="statusClass(form.status)"
        >
          {{ statusText(form.status) }}
        </div>
        <div>
          <p><strong>تفاصيل المنظومات المتوفرة </strong></p>
          <p><strong>(مثلاً: القدرة بالواط، عدد الألواح، نوع البطاريات...) </strong></p>
          <VTextEditor v-model="form.system_details"></VTextEditor>
          <p><strong>المحافظات والمناطق المشمولة بالخدمة</strong></p>
          <VTextEditor v-model="form.covered_locations"></VTextEditor>
          <p><strong>آلية تقديم الخدمة</strong></p>
          <p><strong>(زيارة موقع، استشارة، تجهيز، تركيب، متابعة...)</strong></p>
          <VTextEditor v-model="form.service_process"></VTextEditor>
          <p><strong>نوع الضمان</strong></p>
          <VTextEditor v-model="form.warranty_type"></VTextEditor>
          <p><strong>مدة الضمان:</strong></p>
          <VTextEditor v-model="form.warranty_duration"></VTextEditor>
          <p><strong>بلد المنشأ للمعدات:</strong></p>
          <VTextEditor v-model="form.equipment_origin"></VTextEditor>
          <p><strong>الأسعار (تقديرية أو تفصيلية)</strong></p>
          <VTextEditor v-model="form.pricing"></VTextEditor>
          <p><strong>الوثائق المطلوبة من المواطن عند التقديم (إن وجدت)</strong></p>
          <VTextEditor v-model="form.document"></VTextEditor>
        </div>
      </template>
    </template>
  </VContent>
</template>

<script>
import { clearObject, successAlert, errorAlert } from "@/utils/helper";

export default {
  data() {
    return {
      id: null,
      title: null,
    };
  },
  computed: {
    form: {
      get() {
        return this.$store.state.company.services.form;
      },
      set(value) {
        this.$store.commit("company/services/SET_TEXT", value);
      },
    },
  },
  watch: {
    $route() {
      this.getServices(); 
    },
  },
  mounted() {
    this.scrollToTop();
    this.getServices(); 
  },
  methods: {
    getServices() {
      this.$store
        .dispatch("company/services/get")
        .catch(() => errorAlert("فشل في جلب البيانات"));
    },
    updateServices() {
      this.$store
        .dispatch("company/services/update")
        .then(() => successAlert("تم تحديث البيانات بنجاح"))
        .catch(() => errorAlert("فشل في تحديث البيانات"));
    },
    clearForm() {
      this.form = clearObject(this.form);
      this.$emit("close");
    },
    statusClass(status) {
      return {
        green: status === 1,
        error: status === 2,
        pending: status === 0,
      };
    },
    statusText(status) {
      return status === 1
        ? "تم القبول"
        : status === 2
        ? "تم الرفض"
        : status === 0
        ? "جاري المراجعة"
        : "";
    },
    scrollToTop() {
      window.scrollTo(0, 0);
    },
  },
};
</script>
<style></style>
